import { fetchBaseUrl } from "core/utils/common";
const apiURL = `${fetchBaseUrl({ port: 8000 })}/eaas/api`;
// Fetch policies
export async function apiCallWithBearerToken(
  url: string,
  bearerToken: string,
  options: RequestInit = {}
) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': bearerToken,
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    throw new Error(`API call failed: ${response.statusText}`);
  }

  return response.json();
}

export async function fetchPolicies(account: string, bearerToken: string) {
  return apiCallWithBearerToken(
    `${apiURL}/filters/policies?${account}`,
    bearerToken,
    { method: 'GET' }
  );
}


// Fetch categories
export async function fetchCategories(account: string, bearerToken: string) {
  return apiCallWithBearerToken(
    `${apiURL}/filters/categories?${account}`,
    bearerToken,
    { method: 'GET' }
  );
}



// Fetch resource types
export async function fetchResourceTypes(account: string, bearerToken: string) {
  return apiCallWithBearerToken(
    `${apiURL}/filters/resource-types?${account}`,
    bearerToken,
    { method: 'GET' }
  );
}

export async function fetchResource(account: string, bearerToken: string) {
  return apiCallWithBearerToken(
    `${apiURL}/filters/resources?${account}`,
    bearerToken,
    { method: 'GET' }
  );
}

// Combine all filter responses


export async function fetchAccounts(bearerToken: string): Promise<{ account_id: string;
  name: string;
  email: string;}[]> {
  return apiCallWithBearerToken(
    `${apiURL}/accounts`,
    bearerToken,
    { method: 'GET' }
  );
}

export async function fetchoperations(payload:any) {
  const response = await fetch(`${apiURL}/aws`,{
      method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }
  );
  if (!response.ok) {
    throw new Error('Failed to fetch operations');
  }
  return response.json();
}

export async function fetchFilteredFindings(filters: any, bearerToken: string) {
  // Build payload with required keys
  const payload = {
    account_name: filters.awsAccount.split("/")[0] || '',
    account_id: filters.awsAccount.split("/")[1] || '',
    profile: filters.profile || '',
    category: filters.resourceCategory || '',
    resource_type: filters.resourceType || '',
    offset: filters.offset || 0,
    resource_ids: filters.resource_ids || [],
    policy_names: filters.policy_names || []
  };

  const data = await apiCallWithBearerToken(
    `${apiURL}/apply-filters`,
    bearerToken,
    { 
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );

  // Map the API response to the new finding object structure for the UI
  return data.findings.map(item => ({
    resource_id: item.resource_id ?? null,
    resource_type: item.resource_type ?? null,
    policy_name: item.policy_name ?? '',
    control_description: item.control_description ?? '-',
    status: item.status,
    severity: item.severity ?? '-',
    account_id: item.account_id ?? '',
    CreationDate: item.timestamp ?? '',
    resource_link: item.resource_link ?? '',
    policy_link: item.policy_link ?? ''
  }));
}


export async function downloadPDF(filters: any, bearerToken: string) {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `${bearerToken}`,
  };

  const response = await fetch(`${apiURL}/evidence/summarizepdf`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      "account_id": filters.awsAccount.split("/")[1] || '',
      "category": filters.resourceCategory,
      "resource_type": filters.resourceType,
      "limit": filters.limit,
      "offset": 0,
      "resource_ids": filters.resource_ids || [],
      "policy_names": filters.policy_names || []
    })
  });
    
  if (!response.ok) {
    throw new Error('Failed to download PDF');
  }     

  const blob = await response.blob();
  // Create a link element to trigger the download
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'evidence.pdf';
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
